// Static lists for the reseller New Client Setup form.

// The client list and console numbers now come from /resellers/clients and
// /resellers/console/summary. INDUSTRIES is the fallback for
// /resellers/industries.
export const INDUSTRIES = ["Automotive", "Banking", "Education", "Healthcare", "Insurance", "Retail", "Telecom"];

export const CLIENT_ROLES = ["Admin", "Customer Support", "Marketing", "Sales"];

export const COUNTRY_STATES: Record<string, string[]> = {
  Nigeria: ["Abuja (FCT)", "Enugu", "Kaduna", "Kano", "Lagos", "Ogun", "Oyo", "Rivers"],
  India: ["Delhi", "Gujarat", "Karnataka", "Kerala", "Maharashtra", "Tamil Nadu", "Telangana", "West Bengal"],
  Ghana: ["Ashanti", "Central", "Eastern", "Greater Accra", "Northern", "Western"],
  Kenya: ["Kiambu", "Kisumu", "Mombasa", "Nairobi", "Nakuru"],
};
